// import { createRouter, createWebHistory } from "vue-router";
// import { createRouter, createMemoryHistory } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";

import Home from "@/views/HomePage.vue";

// Top Header Nav
import AdmissionView from "@/views/AdmissionView.vue";
import GalleryView from "@/views/GalleryView.vue";
import PlacementView from "@/views/PlacementView.vue";
import ContactView from "@/views/ContactView.vue";

// About Nav
import AboutCollegeView from "@/views/about/AboutCollegeView.vue";
import CampusView from "@/views/about/CampusView.vue";
import LeadershipMessageView from "@/views/about/LeadershipMessageView.vue";
import PrincipalMessageView from "@/views/about/PrincipalMessageView.vue";
import AffiliationView from "@/views/about/AffiliationView.vue";
import OrganogramView from "@/views/about/OrganogramView.vue";
import GoverningBodyView from "@/views/about/GoverningBodyView.vue";

// Academics Nav
import DepartmentView from "@/views/academics/DepartmentView.vue";
import SyllabusView from "@/views/academics/SyllabusView.vue";
import SubjectsView from "@/views/academics/SubjectsView.vue";
import VocationCenterView from "@/views/academics/VocationCenterView.vue";
import DLCView from "@/views/academics/DLCView.vue";

import AcademicCalendarView from "@/views/academics/AcademicCalendarView.vue";
import TeachingStaffView from "@/views/academics/TeachingStaffView.vue";
import NonTeachingStaffView from "@/views/academics/NonTeachingStaffView.vue";
import CollaborationView from "@/views/academics/CollaborationView.vue";
import EResourcesView from "@/views/academics/EResourcesView.vue";

// Admission Nav
import ApplyNowView from "@/views/admission/ApplyNowView.vue";
import ProgramOfferedView from "@/views/admission/ProgramOfferedView.vue";
import EligiblityCriteriaView from "@/views/admission/EligiblityCriteriaView.vue";
import FeeDetailsView from "@/views/admission/FeeDetailsView.vue";
import ScholarshipView from "@/views/admission/ScholarshipView.vue";
import CollegeBrochureView from "@/views/admission/CollegeBrochureView.vue";
import AdmissionCommitteeView from "@/views/admission/AdmissionCommitteeView.vue";

// Student Corner Nav
import AchievementsView from "@/views/studentcorner/AchievementsView.vue";
import AlumniView from "@/views/studentcorner/AlumniView.vue";
import PoliciesView from "@/views/studentcorner/PoliciesView.vue";
import AntiRaggingView from "@/views/studentcorner/AntiRaggingView.vue";
import BestPractiseView from "@/views/studentcorner/BestPractiseView.vue";
import CodeOfConductView from "@/views/studentcorner/CodeOfConductView.vue";

import CellsView from "@/views/studentcorner/CellsView.vue";
import WDCView from "@/views/studentcorner/WDCView.vue";
import NSSView from "@/views/studentcorner/NSSView.vue";
import ScoutView from "@/views/studentcorner/ScoutView.vue";
import SportClubView from "@/views/studentcorner/SportClubView.vue";
import MentorMenteeView from "@/views/studentcorner/MentorMenteeView.vue";
import TopperView from "@/views/studentcorner/TopperView.vue";
import DonateNowView from "@/views/studentcorner/DonateNowView.vue";

// Publication Nav
import BooksView from "@/views/publication/BookView.vue";
import NewsletterView from "@/views/publication/NewsletterView.vue";
import MediaView from "@/views/publication/MediaView.vue";
import EditorialBoardView from "@/views/publication/EditorialBoardView.vue";

// IQAC Nav
import IqacAboutView from "@/views/iqac/IqacAboutView.vue";
import IqacCompositionView from "@/views/iqac/IqacCompositionView.vue";
import IqacMeetingView from "@/views/iqac/IqacMeetingView.vue";
import IqacNoticesView from "@/views/iqac/IqacNoticesView.vue";
import AqarView from "@/views/iqac/AqarView.vue";
import ClubCommitteeView from "@/views/iqac/ClubCommitteeView.vue";
import IqacCommitteeView from "@/views/iqac/IqacCommitteeView.vue";
import EnrichmentInitiative from "@/views/iqac/EnrichmentInitiativeVue.vue";


// NAAC Nav
import NaacCertificateView from "@/views/naac/NaacCertificateView.vue";
import AisheView from "@/views/naac/AisheView.vue";
import IDView from "@/views/naac/IDView.vue";
import BestPractisesView from "@/views/naac/BestPractisesView.vue";
import CriteriaView from "@/views/naac/CriteriaView.vue";
import PeerReviewView from "@/views/naac/PeerReviewView.vue";
import SSRDocumentsView from "@/views/naac/ssr_documents/SSRDocumentsView.vue";
import SSRDCriteria1View from "@/views/naac/ssr_documents/SSRDCriteria1View.vue";
import SSRDCriteria2View from "@/views/naac/ssr_documents/SSRDCriteria2View.vue";
import DVVCriteriaView from "@/views/naac/ssr_documents/DVVCriteriaView.vue";
import NIRFView from "@/views/naac/NIRFDocumentsView.vue";

// Departments
import ArtsDeptView from "@/views/academics/ArtsDeptView.vue";
import CommerceDeptView from "@/views/academics/CommerceDeptView.vue";
import ScienceDeptView from "@/views/academics/ScienceDeptView.vue";

import NotFound from "@/components/NotFound.vue";



const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/admission",
    name: "Admission",
    component: AdmissionView,
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: GalleryView,
  },
  {
    path: "/placement",
    name: "Placement",
    component: PlacementView,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },
  // about nav
  {
    path: "/aboutcollege",
    name: "AboutCollege",
    component: AboutCollegeView,
  },
  {
    path: "/campus",
    name: "Campus",
    component: CampusView,
  },
  {
    path: "/leadershipmessage",
    name: "LeadershipMessage",
    component: LeadershipMessageView,
  },
  {
    path: "/principalmessage",
    name: "PrincipalMessage",
    component: PrincipalMessageView,
  },
  {
    path: "/affiliation",
    name: "Affiliation",
    component: AffiliationView,
  },
  {
    path: "/organogram",
    name: "Organogram",
    component: OrganogramView,
  },
  {
    path: "/governingbody",
    name: "GoverningBody",
    component: GoverningBodyView,
  },

  // academics Nav
  {
    path: "/department",
    name: "DepartmentView",
    component: DepartmentView,
  },
  {
    path: "/syllabus",
    name: "SyllabusView",
    component: SyllabusView,
  },
  {
    path: "/subjects",
    name: "SubjectsView",
    component: SubjectsView,
  },
  {
    path: "/vocationalcenter",
    name: "VocationCenterView",
    component: VocationCenterView,
  },
  {
    path: "/dlc",
    name: "DLCView",
    component: DLCView,
  },
  {
    path: "/academiccalender",
    name: "AcademicCalendarView",
    component: AcademicCalendarView,
  },
  {
    path: "/teachingstaff",
    name: "TeachingStaffView",
    component: TeachingStaffView,
  },
  {
    path: "/nonteachingstaff",
    name: "NonTeachingStaffView",
    component: NonTeachingStaffView,
  },
  {
    path: "/collaboration",
    name: "CollaborationView",
    component: CollaborationView,
  },
  {
    path: "/eresources",
    name: "EResourcesView",
    component: EResourcesView,
  },

  // Admission Nav
  {
    path: "/applynow",
    name: "ApplyNowView",
    component: ApplyNowView,
  },
  {
    path: "/programoffered",
    name: "ProgramOfferedView",
    component: ProgramOfferedView,
  },
  {
    path: "/eligiblitycriteria",
    name: "EligiblityCriteriaView",
    component: EligiblityCriteriaView,
  },
  {
    path: "/feedetails",
    name: "FeeDetailsView",
    component: FeeDetailsView,
  },
  {
    path: "/scholarship",
    name: "ScholarshipView",
    component: ScholarshipView,
  },
  {
    path: "/collegebrochure",
    name: "CollegeBrochureView",
    component: CollegeBrochureView,
  },
  {
    path: "/admissioncommittee",
    name: "AdmissionCommitteeView",
    component: AdmissionCommitteeView,
  },

  // Student Corner Nav
  {
    path: "/achievements",
    name: "AchievementsView",
    component: AchievementsView,
  },
  {
    path: "/alumni",
    name: "AlumniView",
    component: AlumniView,
  },
  {
    path: "/cells",
    name: "CellsView",
    component: CellsView,
  },
  {
    path: "/policies",
    name: "PoliciesView",
    component: PoliciesView,
  },
  {
    path: "/antiragging",
    name: "AntiRaggingView",
    component: AntiRaggingView,
  },
  {
    path: "/bestpractise",
    name: "BestPractiseView",
    component: BestPractiseView,
  },
  {
    path: "/codeofconduct",
    name: "CodeOfConductView",
    component: CodeOfConductView,
  },
  {
    path: "/wdc",
    name: "WDCView",
    component: WDCView,
  },
  {
    path: "/nss",
    name: "NSSView",
    component: NSSView,
  },
  {
    path: "/scout",
    name: "ScoutView",
    component: ScoutView,
  },
  {
    path: "/sportsclub",
    name: "SportClubView",
    component: SportClubView,
  },
  {
    path: "/mentormentee",
    name: "MentorMenteeView",
    component: MentorMenteeView,
  },
  {
    path: "/toppers",
    name: "TopperView",
    component: TopperView,
  },
  {
    path: "/donate",
    name: "DonateNowView",
    component: DonateNowView,
  },
  // Publication Nav
  
  {
    path: "/books",
    name: "BooksView",
    component: BooksView,
  },
  {
    path: "/newsletter",
    name: "NewsletterView",
    component: NewsletterView,
  },
  {
    path: "/media",
    name: "MediaView",
    component: MediaView,
  },
  {
    path: "/editorialboard",
    name: "EditorialBoardView",
    component: EditorialBoardView,
  },

  // IQAC
  {
    path: "/iqacabout",
    name: "IqacAboutView",
    component: IqacAboutView,
  },
  {
    path: "/iqaccomposition",
    name: "IqacCompositionView",
    component: IqacCompositionView,
  },
  {
    path: "/iqacmeeting",
    name: "IqacMeetingView",
    component: IqacMeetingView,
  },
  {
    path: "/iqacnotices",
    name: "IqacNoticesView",
    component: IqacNoticesView,
  },
  {
    path: "/aqar",
    name: "AqarView",
    component: AqarView,
  },
  {
    path: "/clubcommittee",
    name: "ClubCommittee",
    component: ClubCommitteeView,
  },
  {
    path: "/iqaccommittee",
    name: "IqacCommittee",
    component: IqacCommitteeView,
  },
  {
    path: "/enrichmentinitiative",
    name: "enrichmentinitiative",
    component: EnrichmentInitiative,
  },
  // NAAC
  {
    path: "/naaccertificate",
    name: "NaacCertificate",
    component: NaacCertificateView,
  },
  {
    path: "/aishe",
    name: "AisheView",
    component: AisheView,
  },
  {
    path: "/institutionaldistinctiveness",
    name: "IDView",
    component: IDView,
  },
  {
    path: "/bestpractises",
    name: "BestPractisesView",
    component: BestPractisesView,
  },
  {
    path: "/criteria",
    name: "CriteriaView",
    component: CriteriaView,
  },
  {
    path: "/peerreview",
    name: "PeerReviewView",
    component: PeerReviewView,
  },
  {
    path: "/ssrdocuments",
    name: "SSRDocumentsView",
    component: SSRDocumentsView,
  },
  {
    path: "/ssrdcriteria1",
    name: "SSRDCriteria1View",
    component: SSRDCriteria1View,
  },
  {
    path: "/ssrdcriteria2",
    name: "SSRDCriteria2View",
    component: SSRDCriteria2View,
  },
  {
    path: "/dvvcriteriaview",
    name: "DVVCriteriaView",
    component: DVVCriteriaView,
  },
  {
    path: "/nirfView",
    name: "NIRFView",
    component: NIRFView,
  },
  {
    path: "/artsdepartment",
    name: "ArtsDeptView",
    component: ArtsDeptView,
  },
  {
    path: "/commercedepartment",
    name: "CommerceDeptView",
    component: CommerceDeptView,
  },
  {
    path: "/sciencedepartment",
    name: "ScienceDeptView",
    component: ScienceDeptView,
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
